module.exports = __webpack_public_path__ + "static/media/code.9446a59e.png";